import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormControl, AbstractControl, UntypedFormGroup } from '@angular/forms';
import { GetCommonStudyDescription } from '@app/api-module/control-centre-api-client';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

const INTEGER_PATTERN_REGEX = /^([0-9])+$/;

@Component({
    selector: 'app-study-row',
    templateUrl: './study-row.component.html'
})
export class StudyRowComponent implements OnInit, OnDestroy {
    // A list of forms with controls: modality, studyId, noOfImages, accessionNumber and studyDescription
    @Input()
    studyForm: UntypedFormGroup;

    @Input()
    rowIndex: number;

    @Input()
    commonStudies: GetCommonStudyDescription[];

    @Input()
    modalityList: string[];

    @Input()
    studiesGroups: Map<string, GetCommonStudyDescription[]>;

    studyOptions: Observable<GetCommonStudyDescription[]>;

    @Output()
    studyChange = new EventEmitter<{ studyId: number; rowIndex: number }>();

    searchControl: UntypedFormControl = new UntypedFormControl();

    private readonly subscriptions = new Subscription();

    ngOnInit() {
        this.subscriptions.add(
            this.studyForm.controls.modality.valueChanges.subscribe(() => {
                this.searchControl.reset();
            })
        );

        this.studyOptions = combineLatest([this.studyForm.controls.modality.valueChanges, this.searchControl.valueChanges]).pipe(
            map(([modality, search]) => {
                if (!search || search.length === 0) {
                    return this.studiesGroups.get(modality);
                } else {
                    search = search.toLowerCase();
                    return this.studiesGroups.get(modality).filter(study => study.description.toLowerCase().indexOf(search) > -1);
                }
            })
        );

        this.subscriptions.add(
            this.studyForm.controls.studyId.valueChanges.subscribe(studyId => {
                this.studyChange.emit({ studyId, rowIndex: this.rowIndex });
            })
        );
    }

    inputDigitOnly(event): boolean {
        return INTEGER_PATTERN_REGEX.test(event.key);
    }

    integerOnly(control: AbstractControl) {
        if (!INTEGER_PATTERN_REGEX.test(control.value)) {
            control.setValue(null);
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
